import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComboGrauInstrucaoComponent } from './combo-grau-instrucao.component';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { ComboPesquisavelModule } from '../combo-pesquisavel/combo-pesquisavel.module';



@NgModule({
  declarations: [ComboGrauInstrucaoComponent],
  imports: [
    CommonModule,
    MaterialCommonModule,
    MatExpansionModule,
    ComboPesquisavelModule
  ],
  exports:[ComboGrauInstrucaoComponent]
})
export class ComboGrauInstrucaoModule { }
